import { createContext, useContext, useState, useCallback } from "react";

const BriefingContext = createContext({
  open: false,
  openBriefing: () => {},
  closeBriefing: () => {},
});

export const BriefingProvider = ({ children }) => {
  const [open, setOpen] = useState(false);

  const openBriefing = useCallback(() => setOpen(true), []);
  const closeBriefing = useCallback(() => setOpen(false), []);

  return (
    <BriefingContext.Provider value={{ open, openBriefing, closeBriefing, setOpen }}>
      {children}
    </BriefingContext.Provider>
  );
};

export const useBriefing = () => useContext(BriefingContext);
